import apiClient from "./apiClient";

const BASE = "/api/Product";

const toPayload = (data) => ({
  itemName: data.itemName || data.productName || "",
  itemCategory: data.itemCategory,
  unit: data.unit,
  purchaseRate: Number(data.purchaseRate) || null,
  sellingRate: Number(data.sellingRate) || null,
  minimumStockLevel: Number(data.minimumStockLevel) || null,
  defaultSupplierID: Number(data.defaultSupplierID) || null,
  status: data.status,
});

export const getProducts = () => apiClient.get(`${BASE}/all`);
export const getProduct = (id) => apiClient.get(`${BASE}/${id}`);
export const getProductsByCategory = (category) => apiClient.get(`${BASE}/category/${category}`);
export const createProduct = (data) => apiClient.post(`${BASE}/save`, toPayload(data));
export const updateProduct = (id, data) => apiClient.post(`${BASE}/save`, { ...toPayload(data), productID: id });
export const deleteProduct = () => Promise.reject(new Error("Delete not supported by API"));
